<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Aperçu document</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <form class="columns is-gapless is-column is-minH100">
        <div
          class="column"
          v-if="device === 'desktop'"
          style="flex-basis: auto;">
          <!-- Style pour safari -->
          <iframe
            @load="loading = false"
            :src="link"
            width="100%"
            height="100%"
            style="border: none; min-height: calc(100vh - 150px);">
            <p>Your browser does not support PDFs.
            <a :href="link">Download the PDF</a>.</p>
          </iframe>
        </div>
        <div class="column is-narrow columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
          <div
            class="column"
            :class="[device == 'desktop' ? 'is-4' : 'is-5']">
            <button
              @click="close()"
              class="button is-transform-none is-light is-fullwidth">
              <span>Annuler</span>
            </button>
          </div>
          <div
            class="column is-margin-left-small"
            :class="[device == 'desktop' ? 'is-4' : 'is-5']">
            <button
              @click="download(link)"
              type="button"
              class="button is-transform-none is-success is-fullwidth">
              <span>Télécharger</span>
              <span class="icon">
                <i class="fas fa-download"></i>
              </span>
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DocumentPreview',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['device']),
    link () {
      return this.params.link
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    download (file) {
      let link = document.createElement('a')
      link.href = file
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
